import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const AreaAgentOrResponsible = z.object({
  isSubAreaAttendant: z.boolean(),
  persona: PersonaInfoSummary
})
export type AreaAgentOrResponsible = z.infer<typeof AreaAgentOrResponsible>

export const AreaAgentOrResponsibleList = AreaAgentOrResponsible.array()
export type AreaAgentOrResponsibleList = z.infer<
  typeof AreaAgentOrResponsibleList
>
